import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';

const ANIMATION_DURATION = 200;

const ToastItem = ({ onClose, sticky, timeout, variant, title, message }) => {
  const closingRef = useRef(null);
  const [visible, setVisible] = useState(false);

  // cleanup ref
  useEffect(() => {
    return () => {
      if (closingRef.current) {
        clearTimeout(closingRef.current);
      }
    }
  }, []);

  // Fade in after mount
  useEffect(() => {
    const frame = requestAnimationFrame(() => {
      setVisible(true);
    });
    return () => cancelAnimationFrame(frame);
  }, []);

  // Auto close
  useEffect(() => {
    if (sticky || timeout <= 0) return;

    const timer = setTimeout(() => {
      handleClose();
    }, timeout);
    return () => clearTimeout(timer);
  }, [sticky, timeout]);

  const handleClose = () => {
    setVisible(false);

    closingRef.current = setTimeout(() => {
      onClose();
      if (closingRef.current) {
        closingRef.current = null;
      }
    }, ANIMATION_DURATION);
  };

  return (
    <div
      className={classNames('toast d-block fade', `text-bg-${variant}`, { show: visible })}
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
    >
      {title ? (
          <>
            <div className="toast-header">
              <strong className="me-auto">{title}</strong>
              <button type="button" className="btn-close" aria-label="Close" onClick={handleClose} />
            </div>
            <div className="toast-body">{message}</div>
          </>
      ) : (
          <div className="d-flex align-items-center">
            <div className="toast-body flex-grow-1">{message}</div>
            <div className="pe-2">
              <button type="button" className="btn-close btn-close-white" aria-label="Close" onClick={handleClose} />
            </div>
          </div>
      )}
    </div>
  );
};
ToastItem.propTypes = {
  onClose: PropTypes.func.isRequired,
  sticky: PropTypes.bool.isRequired,
  timeout: PropTypes.number.isRequired,
  variant: PropTypes.string.isRequired,
  title: PropTypes.string,
  message: PropTypes.string,
};
export default ToastItem;
